import React from 'react';

interface FarmPermissionsProps {}

// eslint-disable-next-line no-empty-pattern
export const FarmPermissions = ({}: FarmPermissionsProps) => {
  return (
    <>
      <p>Farm Permisisons</p>
    </>
  );
};
